import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export class TarfinProProductPriceService {
  static getProducts() {
    return RetailerApiClient.get('tarfin-pro-product-prices')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getMarketInfo() {
    return RetailerApiClient.get('tarfin-pro-product-prices/get-market-info')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
